import React from "react";

import { Modal } from "react-responsive-modal";
import "react-responsive-modal/styles.css";

import paperclip from "views/contactUs/img/paper-clip.png";
const RaiseTicketPopup = (props) => {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <Modal
        center
        open={props.showTicket}
        onClose={props.onclose}
        classNames={{
          modal: "modal-w38per",
        }}
      >
        <div className="refer-modal lg:p-4 ">
          <div>
            <h2 className="refer-h2 sm-fsize16 uppercase">RAISE A TICKET</h2>
          </div>

          <div className="">
            <form action="">
              <div className="">
                <div class="form-group modal-form-cs">
                  <label for="">Your Query</label>
                  <input
                    type="text"
                    placeholder=""
                    className="h-79px pb-12 fsize16"
                    value="Address"
                  />
                </div>

                <div className="modal-form-cs pt-6">
                  <label for="">Reference</label>
                  <div class="form-group items-center h-42px p-3 modal-form-cs w-full flex  bord-radius">
                    <div className="mr-2">
                      <img src={paperclip} alt="paperclip" />
                    </div>
                    <p className="fsize16 text-black ">Attach file</p>
                  </div>
                </div>

                <div class="w-full fixed-btn mt-6">
                  <a class="btn btn-orange-otp btn-otp mx-auto myBtn" href="#">
                    SUBMIT
                  </a>
                </div>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default RaiseTicketPopup;
